import { type StackProps, IconButton, Flex, Stack } from "@chakra-ui/react";
import { useTranslation } from "next-i18next";
import { ArrowLeftIcon, Text } from "@looksrare/uikit";
import { InputPanelView } from "../types";
import { FlipperGameStore } from "../hooks/useFlipper";
import { RefundStep } from "./TransactionSteps";

interface RefundTransactionViewProps extends StackProps {
  claimRefund: FlipperGameStore["claimRefund"];
  setView: (view: InputPanelView) => void;
  onRefundComplete: () => void;
  onRefundError: () => void;
}

export const RefundTransactionView = ({
  setView,
  claimRefund,
  onRefundComplete,
  onRefundError,
  ...props
}: RefundTransactionViewProps) => {
  const { t } = useTranslation();

  return (
    <Stack
      width={{ base: "100%", md: "320px" }}
      flexShrink={0}
      spacing={0}
      pt={0}
      borderRadius="dialog"
      bg="rgba(255, 255, 255, 0.09)"
      alignSelf="flex-start"
      key="confirmEntry"
      {...props}
    >
      {/* Header */}
      <Flex p={4} gap={4} width="100%" alignItems="center">
        <IconButton
          aria-label="back"
          size="sm"
          variant="ghost"
          colorScheme="secondary"
          onClick={() => setView(InputPanelView.Default)}
        >
          <ArrowLeftIcon />
        </IconButton>
        <Text bold>{t("flipper::Claim Refund")}</Text>
      </Flex>
      {/* Body */}
      <Stack px={4} pt={6} pb={8} spacing={1}>
        <Text mt={3} textStyle="detail">
          {t("flipper::Confirm your refund claim in your wallet app.")}
        </Text>
      </Stack>
      <Stack px={4} pb={4}>
        <RefundStep
          status={"current"}
          isCurrentStep={true}
          onComplete={onRefundComplete}
          onError={onRefundError}
          claimRefund={claimRefund}
          width="100%"
        />
      </Stack>
    </Stack>
  );
};
